export const content = {
  'SEC-001': {
    title: '《万物来潮》宁乡·时代奥特莱斯沉浸式艺术装置提案',
    subtitle: '一套空间骨架，两套主题视觉系统',
    body: '依托宁乡·九龙仓时代奥特莱斯的独特水景属性，围绕中心喷泉场域，打造一套可持续复用的空间骨架，结合不同主题皮肤，实现无缝主题切换。',
    scrollLabel: '向下滚动探索',
  },
  'SEC-002': {
    title: '宏大空间布局与商业引流场域',
    subtitle: '中央精神堡垒 × 外围环形市集',
    body: '中央“万物来潮”艺术装置作为空间精神核心，承担视觉焦点、拍照节点、入口空间与文化展示功能。外围设置环形市集模块，承载文创展示、非遗体验与文化消费。',
    data: {
      installation: '中央装置：直径 14m，高度 4m。',
      market: '主题市集：数量 25个。',
      booth: '摊位尺寸：宽度 2.0-2.5m，深度 1.2-1.5m，高度 2.4-2.8m。',
    },
  },
  'SEC-003': {
    title: '东方轻质表达与节庆换肤升级',
    subtitle: '基础版本《青铜万象》 ➔ 新春版本《花开新岁》',
    body: '保持主体结构不变，主体采用钢架结构镀漆、户外油画布、进口亚克力板等东方轻结构语言，通过视觉换肤实现节庆升级，打造极具性价比的持续引流引擎。',
    compareLabel: '滑动对比',
  },
  'SEC-004': {
    title: '从“快速观看”到“全民共创”',
    subtitle: '提升停留时间 · 增强社交传播 · 增加家庭客群',
    body: '设置互动体验区，提升商业空间亲子吸引力，游客作品天然形成社交媒体传播内容。',
    graffiti: '共创涂鸦墙：让游客通过绘画、涂色自由创作，将传统展示墙转变为动态生成艺术。',
    threads: '潮生四羊连线互动墙：观众通过彩色线绳在不同点位间连接，最终逐渐“生长”出完整的四羊方尊图形。',
    data: '涂鸦墙与连线墙尺寸：长度 6-8m，高度 2-2.5m。',
  },
  'SEC-005': {
    title: '从视觉体验到文化体验',
    subtitle: '青铜文化与器物故事输出',
    body: '展示区承担文化内容输出功能。通过青铜文化、东方纹样、器物故事的展示，从视觉打卡升级为深度文化体验。',
    data: '单组展示牌尺寸：宽 1200-1500mm，高 2000mm。',
  },
  'SEC-006': {
    title: '万物来潮，如约而至',
    body: '从青铜万象的历史回响，到花开新岁的节庆欢歌。这不仅是一次视觉的升维，更是为宁乡·九龙仓时代奥特莱斯量身打造的文化引流场域。',
  },
} as const
